import { render, staticRenderFns } from "./batchUpdateAmountModal.vue?vue&type=template&id=4b77b012&lang=html"
import script from "./batchUpdateAmountModal.vue?vue&type=script&lang=js"
export * from "./batchUpdateAmountModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_5cxdem7bu5cwsxatf4y6tpyoxu/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports